import { Alignment } from "@mcleod/core";
import { ImageName } from "@mcleod/images";
import { DataDisplayEvent, Label } from "@mcleod/components";
import { AutogenLayoutFtlCommodityLookup } from "./autogen/AutogenLayoutFtlCommodityLookup";

export class FtlCommodityLookup extends AutogenLayoutFtlCommodityLookup {
    labelHazmatOnDataDisplay(event: DataDisplayEvent) {
        const label = event.target as Label;
        label.text = null;
        if (event.rowData?.get("is_hazmat") === "Y") {
            label.imageName = ImageName.warning;
            label.imageColor = "red";
            label.imageAlign = Alignment.LEFT;
        }
    }
}
